export enum PageHeadTagTypes {
  FreeContent,
  Login,
  Landing,
  SignUp,
  Empty,
  CategoryContent,
  Profile,
}
